/* Purchase options (packs + Subscribe & Save modal).
   This was a 60KB inline <script> at the foot of snippets/purchase-options.liquid,
   re-parsed on every product view; moved to an asset on 5 Sep 2026 so it is
   cached across product pages and the PDP HTML is 60KB lighter. The snippet
   still emits the per-product data as window.__PO_DATA just before this file.
   Nothing else about the script changed. */
(function(){
  var PO_DATA = window.__PO_DATA || {};
  var PO_VARIANTS = PO_DATA.variants || [];
  var PO_GROUPS   = PO_DATA.groups || [];
  var MONEY_FORMAT = PO_DATA.money || '';

  // ---------- Recommended frequency lookup (pack count -> weeks) ----------
  // SAME table is used both for: (a) auto-selecting the dropdown plan in Subscribe & Save,
  // and (b) the "Your plan renews to a..." text on the Starter card.
  var RECOMMENDED_WEEKS_BY_COUNT = {
    1: 1,
    3: 2,
    4: 3,
    6: 4,
    8: 5,
    10: 6,
    12: 7,
    24: 10
  };
  // Bottles do not fit that table. A case is 18, 36 or 72 bottles and none of
  // those is in it, so the count/2 fallback was recommending a delivery of 18
  // bottles every 9 weeks and of 36 or 72 every 10 - about half a bottle a day.
  // Sam, 10 Sep 2026: on bottle products the cadence is 2, 3 and 4 weeks for
  // the first, second and third Subscribe & Save pack. Keyed on POSITION, not
  // on how many bottles are in the case, so changing a pack size cannot
  // silently change the recommendation. Filled in once groups.subscription
  // exists; stays null on every other product, leaving the table untouched.
  var BOTTLE_WEEKS_BY_POSITION = [2, 3, 4];
  var bottleWeeksByCount = null;
  function recommendedWeeksForCount(count) {
    if (bottleWeeksByCount && bottleWeeksByCount.hasOwnProperty(count)) return bottleWeeksByCount[count];
    if (RECOMMENDED_WEEKS_BY_COUNT.hasOwnProperty(count)) return RECOMMENDED_WEEKS_BY_COUNT[count];
    return Math.max(1, Math.min(10, Math.floor(count / 2)));
  }
  function weeksToPhrase(weeks) {
    if (weeks == null) return 'subscription';
    return weeks === 1 ? 'every week' : 'every ' + weeks + ' weeks';
  }

  // ---------- English-aware singular -> plural ----------
  function pluralize(word) {
    if (!word) return '';
    var lower = word.toLowerCase();
    // s/x/z/ch/sh -> es (box -> boxes, dish -> dishes)
    if (/(?:s|x|z|ch|sh)$/.test(lower)) return word + 'es';
    // consonant + y -> ies (pouch is already covered above; this catches "pouchy" etc.)
    if (/[^aeiou]y$/.test(lower)) return word.slice(0, -1) + 'ies';
    return word + 's';
  }

  // ---------- Helpers ----------
  // rdMoney (assets/redesign.js, loaded before this file) formats in the
  // session's currency, from the shape Shopify printed in the layout's
  // rd-money sample. MONEY_FORMAT below is shop.money_format — the STORE's
  // dollar format whatever currency the page is priced in — and is only the
  // fallback for a page where redesign.js failed to load.
  function fmt(amountCents) {
    if (amountCents == null || isNaN(amountCents)) return '';
    if (window.rdMoney) return window.rdMoney.format(amountCents);
    var dollars = (amountCents / 100);
    var s = MONEY_FORMAT || '${{amount}}';
    return s.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/g, function(_, mod) {
      if (mod === '_no_decimals') return Math.round(dollars).toLocaleString('en-US');
      if (mod === '_with_comma_separator') return dollars.toFixed(2);
      return dollars.toFixed(2);
    });
  }
  function findPlan(planId) {
    for (var i = 0; i < PO_GROUPS.length; i++) {
      var plans = PO_GROUPS[i].selling_plans || [];
      for (var j = 0; j < plans.length; j++) {
        if (Number(plans[j].id) === Number(planId)) return plans[j];
      }
    }
    return null;
  }
  function parsePlanWeeks(plan) {
    if (!plan) return null;
    var s = ((plan.option_value || plan.name || '') + '').toLowerCase();
    var weekMatch = s.match(/(\d+)\s*week/);
    if (weekMatch) return parseInt(weekMatch[1], 10);
    if (/every\s*week/.test(s) || /\bweekly\b/.test(s)) return 1;
    var dayMatch = s.match(/(\d+)\s*day/);
    if (dayMatch) {
      var days = parseInt(dayMatch[1], 10);
      return Math.max(1, Math.round(days / 7));
    }
    return null;
  }
  function getVariantPlans(variant) {
    return (variant.selling_plan_allocations || []).map(function(a){
      var plan = findPlan(a.selling_plan_id);
      return {
        selling_plan_id: a.selling_plan_id,
        selling_plan_group_id: a.selling_plan_group_id,
        price: a.price,
        compare_at_price: a.compare_at_price,
        per_delivery_price: a.per_delivery_price,
        name: plan ? (plan.option_value || plan.name) : ('Plan ' + a.selling_plan_id),
        weeks: parsePlanWeeks(plan)
      };
    });
  }
  function findPlanForWeeks(variant, targetWeeks) {
    var plans = getVariantPlans(variant);
    if (!plans.length) return null;
    var exact = plans.filter(function(p){ return p.weeks === targetWeeks; });
    if (exact.length) return exact[0];
    var withWeeks = plans.filter(function(p){ return p.weeks != null; });
    if (withWeeks.length) {
      withWeeks.sort(function(a, b){
        return Math.abs(a.weeks - targetWeeks) - Math.abs(b.weeks - targetWeeks);
      });
      return withWeeks[0];
    }
    return plans[0];
  }

  // ---------- Container metafield ----------
  var $widget = document.getElementById('po-widget');
  if (!$widget) return;
  var CONTAINER = ($widget.dataset.container || 'can').toLowerCase();
  var CONTAINER_PLURAL = pluralize(CONTAINER);
  function unitWord(count) { return count === 1 ? CONTAINER : CONTAINER_PLURAL; }

  // ---------- Categorize variants ----------
  function categorize() {
    var starter = null;
    var subscriptionCandidates = [];
    var onetime = [];
    var singlePack = null;

    // Pre-count unavailable multi-pack variants (excluding starter + 1-pack).
    // The "lone OOS" cleanup only fires when exactly one multi-pack is sold
    // out — otherwise multiple sold-out SKUs are a real business signal and
    // should display normally (with the greyed/strikethrough treatment).
    // The 1-pack is intentionally excluded from this count: the user wants it
    // to always show regardless of stock state.
    var unavailableMultiCount = 0;
    PO_VARIANTS.forEach(function(v){
      if (!v.sku || v.is_starter) return;
      if (v.sku_count > 1 && !v.available) unavailableMultiCount++;
    });
    var filterLoneOOS = (unavailableMultiCount === 1);

    PO_VARIANTS.forEach(function(v){
      if (!v.sku) return;
      if (v.is_starter) {
        if (!starter) starter = v;
        return;
      }
      // singlePack is used purely for the per-unit BASELINE_PER_UNIT compare
      // price math. We keep it even when out of stock — the "SAVE $X" math on
      // other bundles is anchored to the 1-pack compare price regardless of
      // whether the 1-pack itself is currently buyable.
      if (v.sku_count === 1 && !singlePack) singlePack = v;

      // Lone-OOS cleanup: hide ONLY when this is the single sold-out
      // multi-pack across the whole product. With 0 OOS, this branch never
      // fires. With 2+ OOS, filterLoneOOS is false → all variants render
      // (sold-out ones greyed via .is-sold-out treatment in the bundle button
      // render loops). 1-packs are never filtered here regardless of stock.
      if (filterLoneOOS && !v.available && v.sku_count > 1) return;

      onetime.push(v);
      if (v.sku_count > 1 && v.selling_plan_allocations && v.selling_plan_allocations.length > 0) {
        subscriptionCandidates.push(v);
      }
    });

    // Subscribe & Save: top 3 by pack-count. When filterLoneOOS is true,
    // candidates are already pruned. When false (0 or 2+ OOS), candidates
    // include sold-out variants and the top 3 may include them — they'll
    // render with the dulled/strikethrough treatment, matching how the
    // user wants multi-OOS to display.
    subscriptionCandidates.sort(function(a,b){ return b.sku_count - a.sku_count; });
    var subscription = subscriptionCandidates.slice(0, 3).sort(function(a,b){ return a.sku_count - b.sku_count; });
    onetime.sort(function(a,b){ return a.sku_count - b.sku_count; });

    return { starter: starter, subscription: subscription, onetime: onetime, singlePack: singlePack };
  }
  var groups = categorize();
  if (CONTAINER === 'bottle') {
    bottleWeeksByCount = {};
    groups.subscription.forEach(function (v, i) {
      bottleWeeksByCount[v.sku_count] =
        BOTTLE_WEEKS_BY_POSITION[Math.min(i, BOTTLE_WEEKS_BY_POSITION.length - 1)];
    });
  }

  // ---------- 1-pack non-subscription compare price baseline ----------
  function baselinePerUnit() {
    if (groups.singlePack) {
      return groups.singlePack.compare_at_price || groups.singlePack.price;
    }
    var max = 0;
    groups.onetime.forEach(function(v){
      var per = (v.compare_at_price || v.price) / Math.max(1, v.total_cans);
      if (per > max) max = per;
    });
    return max || 0;
  }
  var BASELINE_PER_UNIT = baselinePerUnit();

  function computeSavings(variantPrice, unitCount) {
    if (!BASELINE_PER_UNIT) return 0;
    return Math.max(0, BASELINE_PER_UNIT * unitCount - variantPrice);
  }
  function isHighSavings(savings, variantPrice, unitCount) {
    if (!BASELINE_PER_UNIT) return false;
    var baseline = BASELINE_PER_UNIT * unitCount;
    if (baseline <= 0) return false;
    return savings >= baseline * 0.20;
  }

  // ---------- State ----------
  // We track each card's selected variant separately so the totals on every
  // card stay accurate as the user changes quantity. The "active" mode
  // determines which variant is submitted to the cart.
  var state = {
    mode: null,            // 'starter' | 'subscription' | 'onetime'
    subVariantId: null,    // currently-picked subscription bundle
    subSellingPlanId: null,
    otVariantId: null,     // currently-picked one-time bundle
    quantity: 1,
    starterDisabled: ($widget.dataset.starterDisabled === 'true'),
    starterDisableReason: $widget.dataset.starterDisableReason || '',
    initializing: true     // true during bootstrap; cleared at end of init
  };

  // ---------- DOM refs ----------
  var $starterCard    = $widget.querySelector('.po-card--starter');
  var $subCard        = $widget.querySelector('.po-card--subscription');
  var $otCard         = $widget.querySelector('.po-card--onetime');
  var $variantInput   = document.getElementById('po-variant-id');
  var $planInput      = document.getElementById('po-selling-plan-id');
  var $qtyInput       = document.getElementById('po-quantity');
  var $planSelect     = document.getElementById('po-plan-select');
  var $subBundles     = document.getElementById('po-sub-bundles');
  var $otBundles      = document.getElementById('po-ot-bundles');
  var $actions        = document.getElementById('po-actions');
  var $qtyMinus       = document.getElementById('po-qty-minus');
  var $qtyPlus        = document.getElementById('po-qty-plus');
  var $qtyDisplay     = document.getElementById('po-qty-input');
  var $atcBtn         = document.getElementById('po-atc-btn');
  var $modal          = document.getElementById('po-modal');

  // ---------- Per-mode price lookup (used by refreshTotals) ----------
  function getStarterPrice() {
    return groups.starter ? groups.starter.price : 0;
  }
  function getSubscriptionPrice() {
    var v = groups.subscription.find(function(x){ return x.id === state.subVariantId; });
    if (!v) return 0;
    var alloc = (v.selling_plan_allocations || []).find(function(a){
      return Number(a.selling_plan_id) === Number(state.subSellingPlanId);
    });
    return alloc ? alloc.price : v.price;
  }
  function getOneTimePrice() {
    var v = groups.onetime.find(function(x){ return x.id === state.otVariantId; });
    return v ? v.price : 0;
  }

  // ---------- Refresh totals on all 3 cards ----------
  // Starter is always × 1 (one per household). Sub & one-time use state.quantity.
  function refreshTotals() {
    if (groups.starter && $starterCard) {
      var starterTotal = $starterCard.querySelector('[data-po="starter-total"]');
      if (starterTotal) setText(starterTotal, 'Total: ' + fmt(getStarterPrice()));
    }
    if (state.subVariantId) {
      var subTotal = $subCard.querySelector('[data-po="sub-total"]');
      if (subTotal) setText(subTotal, 'Total: ' + fmt(getSubscriptionPrice() * state.quantity));
    }
    if (state.otVariantId) {
      var otTotal = $otCard.querySelector('[data-po="ot-total"]');
      if (otTotal) setText(otTotal, 'Total: ' + fmt(getOneTimePrice() * state.quantity));
    }
    updateBundleSavings();
  }

  // Recalculate the "SAVE $X" strip on each bundle button using the current
  // quantity. Only the savings TEXT is updated — the high/normal styling
  // (--high terracotta vs slate) stays as set at initial render, because it
  // reflects per-unit deal quality, not absolute dollar amount. Buying 5 of a
  // 5%-off bundle is still a 5%-off bundle, just with 5x the dollar savings.
  function updateBundleSavings() {
    var qty = state.quantity || 1;

    if ($subBundles) {
      Array.prototype.forEach.call($subBundles.querySelectorAll('.po-bundle-btn'), function(btn){
        var vid = Number(btn.dataset.variantId);
        var v = groups.subscription.find(function(x){ return x.id === vid; });
        if (!v) return;
        // Match the same per-bundle subPrice used at render time:
        // the cheapest available plan allocation, falling back to base price.
        var subPrice = v.price;
        if (v.selling_plan_allocations && v.selling_plan_allocations.length) {
          subPrice = Math.min.apply(null, v.selling_plan_allocations.map(function(a){ return a.price; }));
        }
        var savings = computeSavings(subPrice, v.total_cans) * qty;
        var strip = btn.querySelector('.po-bundle-btn-savings');
        if (strip) strip.textContent = savings > 0 ? 'SAVE ' + fmt(savings) : '';
      });
    }

    if ($otBundles) {
      Array.prototype.forEach.call($otBundles.querySelectorAll('.po-bundle-btn'), function(btn){
        var vid = Number(btn.dataset.variantId);
        var v = groups.onetime.find(function(x){ return x.id === vid; });
        if (!v) return;
        var savings = computeSavings(v.price, v.total_cans) * qty;
        var strip = btn.querySelector('.po-bundle-btn-savings');
        if (strip) strip.textContent = savings > 0 ? 'SAVE ' + fmt(savings) : '';
      });
    }
  }

  // ---------- Render: Starter ----------
  function renderStarter() {
    // If the starter card isn't in the DOM (server skipped it because variant
    // is unavailable), there's nothing to render.
    if (!$starterCard) return;
    if (!groups.starter) {
      $starterCard.hidden = true;
      return;
    }
    if (!groups.starter.available) {
      // Defensive: server should have skipped rendering, but if for some reason
      // the card is in the DOM AND the variant is unavailable, hide it.
      $starterCard.hidden = true;
      return;
    }
    $starterCard.hidden = false;
    var v = groups.starter;
    var perCan = v.price / v.total_cans;
    var compareSingle = BASELINE_PER_UNIT;

    setText($starterCard.querySelector('[data-po="starter-price"]'), fmt(perCan) + '/' + CONTAINER);
    setText($starterCard.querySelector('[data-po="starter-compare"]'), compareSingle > perCan ? fmt(compareSingle) : '');

    var headline;
    if (v.paid_cans < v.total_cans) {
      headline = 'Buy ' + v.paid_cans + ', Get ' + v.total_cans;
    } else {
      headline = v.title;
    }
    setText($starterCard.querySelector('.po-starter-headline'), headline);

    var freeUnits = Math.max(0, v.total_cans - v.paid_cans);
    var pitch;
    if (freeUnits > 0) {
      pitch = 'Buy ' + v.paid_cans + ' ' + unitWord(v.paid_cans) +
              ', get ' + freeUnits + ' ' + unitWord(freeUnits) +
              ' free! New customers only.';
    } else {
      pitch = 'New customers only.';
    }
    setText($starterCard.querySelector('[data-po="starter-pitch"]'), pitch);

    // Renewal: 2nd-highest subscription pack, with frequency from RECOMMENDED_WEEKS_BY_COUNT
    var subDescending = groups.subscription.slice().sort(function(a,b){ return b.sku_count - a.sku_count; });
    var renewTarget = subDescending[1] || subDescending[0];
    var renewMsg;
    if (renewTarget) {
      var renewWeeks = recommendedWeeksForCount(renewTarget.sku_count);
      renewMsg = renewTarget.sku_count + ' ' + unitWord(renewTarget.sku_count) +
                 ' subscription ' + weeksToPhrase(renewWeeks);
    } else {
      renewMsg = 'subscription';
    }
    setText($starterCard.querySelector('.po-starter-renews'), renewMsg);
  }

  // ---------- Render: Subscribe & Save ----------
  function renderSubscription() {
    if (!groups.subscription.length) {
      $subCard.hidden = true;
      return;
    }
    $subCard.hidden = false;

    $subBundles.innerHTML = '';
    groups.subscription.forEach(function(v){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'po-bundle-btn';
      if (!v.available) btn.classList.add('is-sold-out');
      btn.dataset.variantId = v.id;

      var label;
      if (v.paid_cans < v.total_cans) {
        var freeN = v.total_cans - v.paid_cans;
        label = v.paid_cans + ' + ' + freeN + ' Free ' + capitaliseFirst(unitWord(v.total_cans));
      } else {
        label = v.sku_count + ' ' + capitaliseFirst(unitWord(v.sku_count));
      }
      var labelHtml = '<span class="po-bundle-btn-label">' + escapeHtml(label) + '</span>';

      var subPrice = v.price;
      if (v.selling_plan_allocations && v.selling_plan_allocations.length) {
        subPrice = Math.min.apply(null, v.selling_plan_allocations.map(function(a){ return a.price; }));
      }
      var savings = computeSavings(subPrice, v.total_cans);
      var savingsHtml = '';
      if (savings > 0) {
        var loud = isHighSavings(savings, subPrice, v.total_cans);
        savingsHtml = '<span class="po-bundle-btn-savings' + (loud ? ' po-bundle-btn-savings--high' : '') + '">SAVE ' + fmt(savings) + '</span>';
      }
      btn.innerHTML = labelHtml + savingsHtml;
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        selectSubscriptionVariant(v.id);
      });
      $subBundles.appendChild(btn);
    });
    // Default: prefer the second-smallest available, then any available, else first (UI will be disabled)
    var defaultV = pickDefaultAvailable(groups.subscription);
    if (defaultV) {
      selectSubscriptionVariant(defaultV.id, /*silent*/ true);
    }
  }

  // Pick the second-smallest available variant (matches old "middle option" intent),
  // falling back to first available, falling back to first.
  function pickDefaultAvailable(list) {
    if (!list || !list.length) return null;
    var available = list.filter(function(v){ return v.available; });
    if (!available.length) return list[0];
    var idx = Math.min(1, available.length - 1);
    return available[idx];
  }

  function selectSubscriptionVariant(variantId, silent) {
    var v = groups.subscription.find(function(x){ return x.id === variantId; });
    if (!v) return;
    // Note: we do NOT early-return on !v.available — sold-out variants are still
    // selectable so users can browse pricing/savings. ATC stays disabled via syncAtcDisabled().

    state.subVariantId = v.id;

    Array.prototype.forEach.call($subBundles.querySelectorAll('.po-bundle-btn'), function(b){
      b.classList.toggle('is-active', Number(b.dataset.variantId) === Number(variantId));
    });

    // Build plan select
    $planSelect.innerHTML = '';
    var plans = getVariantPlans(v);
    if (!plans.length) {
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = 'No subscription plan available';
      $planSelect.appendChild(opt);
      $planSelect.disabled = true;
      state.subSellingPlanId = null;
    } else {
      $planSelect.disabled = false;
      plans.sort(function(a, b){
        var aw = a.weeks == null ? 999 : a.weeks;
        var bw = b.weeks == null ? 999 : b.weeks;
        return aw - bw;
      });
      var recommendedWeeks = recommendedWeeksForCount(v.sku_count);
      var recommendedPlan = findPlanForWeeks(v, recommendedWeeks);
      plans.forEach(function(p){
        var opt = document.createElement('option');
        opt.value = p.selling_plan_id;
        var prettyName = (p.name || '').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
        var isRecommended = recommendedPlan && p.selling_plan_id === recommendedPlan.selling_plan_id;
        opt.textContent = prettyName + (isRecommended ? ' (Recommended for ' + v.sku_count + ' ' + unitWord(v.sku_count) + ')' : '');
        $planSelect.appendChild(opt);
      });
      if (recommendedPlan) {
        $planSelect.value = recommendedPlan.selling_plan_id;
        state.subSellingPlanId = recommendedPlan.selling_plan_id;
      } else {
        state.subSellingPlanId = $planSelect.value || null;
      }
    }

    // Header price reflects the chosen plan's price
    var displayPrice = getSubscriptionPrice();
    var perCan = displayPrice / v.total_cans;

    setText($subCard.querySelector('[data-po="sub-price"]'), fmt(perCan) + '/' + CONTAINER);
    setText($subCard.querySelector('[data-po="sub-compare"]'), BASELINE_PER_UNIT > perCan ? fmt(BASELINE_PER_UNIT) : '');

    if (state.mode === 'subscription' || !silent) {
      activateCard('subscription');
    }
    syncFormInputs();
    refreshTotals();
    updatePlanSelectVisibility();
  }

  // ---------- Render: One-Time ----------
  function renderOneTime() {
    if (!groups.onetime.length) {
      $otCard.hidden = true;
      return;
    }
    $otCard.hidden = false;

    $otBundles.innerHTML = '';
    groups.onetime.forEach(function(v){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'po-bundle-btn';
      if (!v.available) btn.classList.add('is-sold-out');
      btn.dataset.variantId = v.id;

      var label = v.sku_count + ' ' + capitaliseFirst(unitWord(v.sku_count));
      var labelHtml = '<span class="po-bundle-btn-label">' + escapeHtml(label.toUpperCase()) + '</span>';

      var savings = computeSavings(v.price, v.total_cans);
      var savingsHtml = '';
      if (savings > 0) {
        var loud = isHighSavings(savings, v.price, v.total_cans);
        savingsHtml = '<span class="po-bundle-btn-savings' + (loud ? ' po-bundle-btn-savings--high' : '') + '">SAVE ' + fmt(savings) + '</span>';
      }
      btn.innerHTML = labelHtml + savingsHtml;
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        selectOneTimeVariant(v.id);
      });
      $otBundles.appendChild(btn);
    });

    var defaultV = pickDefaultAvailable(groups.onetime);
    if (defaultV) {
      selectOneTimeVariant(defaultV.id, /*silent*/ true);
    }
  }

  function selectOneTimeVariant(variantId, silent) {
    var v = groups.onetime.find(function(x){ return x.id === variantId; });
    if (!v) return;
    // Note: we do NOT early-return on !v.available — sold-out variants are still
    // selectable so users can browse pricing/savings. ATC stays disabled via syncAtcDisabled().

    state.otVariantId = v.id;

    Array.prototype.forEach.call($otBundles.querySelectorAll('.po-bundle-btn'), function(b){
      b.classList.toggle('is-active', Number(b.dataset.variantId) === Number(variantId));
    });

    var perCan = v.price / v.total_cans;
    setText($otCard.querySelector('[data-po="ot-price"]'), fmt(perCan) + '/' + CONTAINER);
    setText($otCard.querySelector('[data-po="ot-compare"]'), BASELINE_PER_UNIT > perCan ? fmt(BASELINE_PER_UNIT) : '');

    if (state.mode === 'onetime' || !silent) {
      activateCard('onetime');
    }
    syncFormInputs();
    refreshTotals();
  }

  function selectStarter() {
    if (!groups.starter) return;
    if (!$starterCard) return;       // server didn't render it (variant unavailable)
    if (state.starterDisabled) return; // can't select a disabled card
    activateCard('starter');
    syncFormInputs();
  }

  // ---------- Starter disable (returning customer / in cart / etc.) ----------
  // Reasons map to user-facing badge text:
  //   'returning'    — customer.orders_count > 0 (logged in, has past orders)
  //   'subscriber'   — customer has a Loop / subscription tag
  //   'redeemed'     — customer has 'starter-redeemed' tag (Tym to set up via Flow)
  //   'in_cart'      — starter variant is already in cart (this/another tab)
  var STARTER_DISABLE_LABELS = {
    returning:  'Already a Customer',
    subscriber: 'Active Subscriber',
    redeemed:   'Already Redeemed',
    in_cart:    'Already in Your Cart',
    sold_out:   'Sold Out'
  };
  function disableStarter(reason) {
    if (!groups.starter || !$starterCard) return;
    // If the card is already hidden (e.g. starter variant is unavailable), there's
    // nothing to dull/badge. Mark the state flag so init flow still skips starter,
    // but don't bother painting styles on an invisible element.
    if ($starterCard.hidden) {
      state.starterDisabled = true;
      state.starterDisableReason = reason || state.starterDisableReason || 'returning';
      return;
    }
    state.starterDisabled = true;
    state.starterDisableReason = reason || state.starterDisableReason || 'returning';
    $starterCard.classList.add('is-disabled');
    var badge = $starterCard.querySelector('[data-po="starter-badge"]');
    if (badge) {
      badge.textContent = STARTER_DISABLE_LABELS[state.starterDisableReason] || 'Unavailable';
    }
    // If starter is currently the active mode, fall through to the next-best AVAILABLE option
    if (state.mode === 'starter') {
      var subFallback = pickDefaultAvailable(groups.subscription);
      var otFallback = pickDefaultAvailable(groups.onetime);
      if (subFallback && subFallback.available) {
        selectSubscriptionVariant(subFallback.id);
      } else if (otFallback && otFallback.available) {
        selectOneTimeVariant(otFallback.id);
      } else {
        // Nothing available anywhere — clear active mode so syncAtcDisabled() will
        // disable the cart button.
        state.mode = null;
        [$starterCard, $subCard, $otCard].forEach(function(c){
          if (c) c.classList.remove('is-active');
        });
        applyCardCollapseStates();
        syncAtcDisabled();
      }
    }
    applyCardCollapseStates();
    syncAtcDisabled();
  }

  // ---------- Stock-driven disable for whole cards ----------
  // Subscribe & Save and One-Time cards stay BROWSABLE even when every variant
  // is sold out — the user can still expand and see prices / pack sizes.
  // Per-button sold-out treatment (already applied in renderSubscription /
  // renderOneTime) is the only signal needed there. The ATC button + actions
  // row get hidden globally if there's nothing purchasable anywhere — that's
  // handled in syncAtcDisabled().
  //
  // Starter is special: when its single variant is unavailable, renderStarter
  // hides the card entirely. Eligibility-based disables (returning customer,
  // already redeemed, etc.) are handled separately via disableStarter() and
  // get the dulled-with-badge treatment.
  function applyStockDisableStates() {
    // No-op for now — kept as a hook for future stock-driven UI changes.
  }

  // ---------- ATC button enabled/disabled ----------
  // Disabled when:
  //   (a) no mode is active (couldn't fall through to anything available), OR
  //   (b) the currently-selected variant is unavailable, OR
  //   (c) absolutely nothing across all 3 modes is purchasable
  function syncAtcDisabled() {
    if (!$atcBtn) return;
    var currentVariantAvailable = false;

    if (state.mode === 'starter' && groups.starter && !state.starterDisabled) {
      currentVariantAvailable = !!groups.starter.available;
    } else if (state.mode === 'subscription' && state.subVariantId) {
      var subV = groups.subscription.find(function(x){ return x.id === state.subVariantId; });
      currentVariantAvailable = !!(subV && subV.available);
    } else if (state.mode === 'onetime' && state.otVariantId) {
      var otV = groups.onetime.find(function(x){ return x.id === state.otVariantId; });
      currentVariantAvailable = !!(otV && otV.available);
    }

    // Is there anything purchasable anywhere? Used to hide the actions row entirely.
    var anyPurchasable = false;
    if (groups.starter && groups.starter.available && !state.starterDisabled) anyPurchasable = true;
    if (!anyPurchasable) anyPurchasable = groups.subscription.some(function(v){ return v.available; });
    if (!anyPurchasable) anyPurchasable = groups.onetime.some(function(v){ return v.available; });

    // Hide the entire actions row (qty + ATC) when nothing is purchasable
    if ($actions) {
      $actions.hidden = !anyPurchasable;
    }

    $atcBtn.disabled = !currentVariantAvailable;

    // Always say "Add to Cart" — the row is hidden when there's nothing to add anyway
    var label = $atcBtn.querySelector('.po-atc-label');
    if (label) label.textContent = 'Add to Cart';
  }

  // Async: check current cart for the starter variant. If it's already in cart,
  // disable. Non-blocking — if /cart.js fails, we just don't apply this layer.
  // ---------- Cart fetch (shared, cached) ----------
  // The starter "in cart" check needs the cart's items. We fetch once and
  // cache the promise. The cache is invalidated by invalidateCartCache()
  // after any /cart/add success so that
  // subsequent eligibility re-checks see the freshly-mutated cart instead of
  // a stale snapshot from page load.
  var _cartPromise = null;
  function fetchCart() {
    if (!_cartPromise) {
      _cartPromise = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    return _cartPromise;
  }
  function invalidateCartCache() { _cartPromise = null; }

  function checkCartForStarter() {
    if (!groups.starter || state.starterDisabled) return Promise.resolve();
    return fetchCart().then(function(cart){
      if (!cart || !cart.items) return;
      var starterId = Number(groups.starter.id);
      var found = cart.items.some(function(item){ return Number(item.variant_id) === starterId; });
      if (found) disableStarter('in_cart');
    });
  }

  // ---------- Free shipping bar: not painted from here (29 Sep 2026) ----------
  // This file carried its own painter for every .js-free-shipping bar: the
  // cart plus the selected pack, measured against the store-currency
  // threshold. It never found a bar on a served page: the redesigned product
  // page renders none — the drawer's bar is parked, see
  // snippets/redesign-cart-drawer.liquid — and the cart page, which has the
  // only one, does not load this file. It went when the threshold became a
  // US-dollar constant to convert per currency (docs/MULTI-CURRENCY.md §4.3):
  // snippets/free-shipping.liquid paints every bar, and the product page's
  // own meter is redesign-pdp.js's.

  // ---------- Activate (mode change) ----------
  function activateCard(mode) {
    state.mode = mode;
    [$starterCard, $subCard, $otCard].forEach(function(c){
      if (!c) return;
      c.classList.toggle('is-active', c.dataset.mode === mode);
      var radio = c.querySelector('.po-radio');
      if (radio) radio.checked = (c.dataset.mode === mode);
    });

    applyCardCollapseStates();

    // Starter: hide qty picker and force qty=1 (limited to one per household)
    if ($actions) {
      $actions.classList.toggle('is-no-qty', mode === 'starter');
    }
    if (mode === 'starter' && state.quantity !== 1) {
      // setQuantity will refreshTotals + sync inputs
      setQuantity(1);
    } else {
      refreshTotals();
    }
    updatePlanSelectVisibility();
    syncAtcDisabled();
  }

  // Hide the "SELECT YOUR PLAN" dropdown when the current subscription variant is
  // unavailable (or none is selected because all are sold out). The dropdown is
  // irrelevant if the user can't actually subscribe to anything.
  function updatePlanSelectVisibility() {
    var $planSection = $subCard ? $subCard.querySelector('[data-po-section="plan-select"]') : null;
    if (!$planSection) return;
    var v = groups.subscription.find(function(x){ return x.id === state.subVariantId; });
    var shouldShow = !!(v && v.available);
    $planSection.hidden = !shouldShow;
  }

  // ---------- Accordion expand/collapse driver ----------
  // We use max-height (set via inline style) instead of CSS-only because
  // grid-template-rows: 0fr -> 1fr animation has inconsistent track-sizing
  // behaviour across browsers and can leave content visible. max-height +
  // overflow: hidden is bulletproof.
  //
  // Active card: maxHeight = scrollHeight px → on transitionend → 'none'
  //   (so dynamic content like dropdown changes can resize naturally)
  // Inactive card: maxHeight = scrollHeight px → reflow → '0px'
  //   (animates from current rendered height down to 0)
  function applyCardCollapseStates() {
    var noTransition = $widget.classList.contains('po-widget--no-transition');
    [$starterCard, $subCard, $otCard].forEach(function(c){
      if (!c) return;
      var body = c.querySelector('.po-card-body');
      if (!body) return;
      var shouldBeOpen = c.classList.contains('is-active');
      var isCurrentlyOpen = (body.style.maxHeight === 'none');
      if (shouldBeOpen === isCurrentlyOpen) return; // already in correct state

      if (noTransition) {
        body.style.maxHeight = shouldBeOpen ? 'none' : '0px';
        return;
      }

      if (shouldBeOpen) {
        body.style.maxHeight = body.scrollHeight + 'px';
        var onEnd = function(e) {
          if (e.propertyName !== 'max-height') return;
          body.removeEventListener('transitionend', onEnd);
          if (c.classList.contains('is-active')) {
            body.style.maxHeight = 'none';
          }
        };
        body.addEventListener('transitionend', onEnd);
      } else {
        // Set explicit pixel value so the transition has a concrete starting point
        body.style.maxHeight = body.scrollHeight + 'px';
        body.offsetHeight; // force reflow
        requestAnimationFrame(function(){
          if (!c.classList.contains('is-active')) {
            body.style.maxHeight = '0px';
          }
        });
      }
    });
  }

  // ---------- Form sync ----------
  function getActiveVariantId() {
    if (state.mode === 'starter') return groups.starter ? groups.starter.id : null;
    if (state.mode === 'subscription') return state.subVariantId;
    if (state.mode === 'onetime') return state.otVariantId;
    return null;
  }
  function getActiveSellingPlanId() {
    if (state.mode === 'starter' && groups.starter) {
      var alloc = (groups.starter.selling_plan_allocations || [])[0];
      return alloc ? alloc.selling_plan_id : null;
    }
    if (state.mode === 'subscription') return state.subSellingPlanId;
    return null;
  }
  function syncFormInputs() {
    var vid = getActiveVariantId();
    var pid = getActiveSellingPlanId();
    if ($variantInput) $variantInput.value = vid || '';
    if ($planInput)    $planInput.value    = pid || '';
    if ($qtyInput)     $qtyInput.value     = state.quantity || 1;
    var shopifySelect = document.querySelector('select[name="id"]');
    if (shopifySelect && shopifySelect.id !== 'po-variant-id') {
      try { shopifySelect.value = vid; } catch(e){}
    }
    // Suppress side-effect-y operations during the initial bootstrap. Some
    // themes have listeners on `change` events / URL changes that scroll the
    // page or otherwise react to "user changed the variant" — but on first
    // paint we're just reflecting server state, not a user action.
    if (!state.initializing) {
      if ($variantInput) $variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      try {
        if (vid && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', vid);
          history.replaceState({}, '', url.toString());
        }
      } catch(e){}
    }
    broadcastVariantChange();
  }

  // ---------- Broadcast variant change to external theme code ----------
  // Theme widgets (free shipping bar, product price displays, etc.) typically
  // hook into the theme's variant select via `change` events on `select[name="id"]`,
  // or they scrape price text from elements like `.loop-current-product-price`.
  // Since this widget supersedes the theme's variant select, those signals
  // never fire. We rebroadcast through every common channel so external code
  // that depends on variant changes can pick up our state.
  function broadcastVariantChange() {
    var vid = getActiveVariantId();
    if (!vid) return;
    var unitPrice = 0;
    if (state.mode === 'starter') unitPrice = getStarterPrice();
    else if (state.mode === 'subscription') unitPrice = getSubscriptionPrice();
    else if (state.mode === 'onetime') unitPrice = getOneTimePrice();
    var qty = state.quantity || 1;
    var lineTotalCents = unitPrice * qty;

    // 1) Update the theme's price display element so any code that scrapes its
    //    text content (free shipping bar, etc.) sees the current line total.
    //    The element is visually hidden by us but stays in the DOM for this purpose.
    var priceText = fmt(lineTotalCents);
    var priceNodes = document.querySelectorAll('.loop-current-product-price, #ProductPrice, .product-single__price');
    Array.prototype.forEach.call(priceNodes, function(node){
      // Preserve any nested elements; only update direct text nodes.
      // If the element is just text, this replaces it cleanly.
      var hasOnlyText = node.children.length === 0;
      if (hasOnlyText) {
        node.textContent = priceText;
      } else {
        // Find the first text node and update it
        for (var i = 0; i < node.childNodes.length; i++) {
          if (node.childNodes[i].nodeType === 3 && node.childNodes[i].textContent.trim()) {
            node.childNodes[i].textContent = priceText;
            break;
          }
        }
      }
      // Tag with current variant id so JS can read it programmatically too
      node.dataset.poVariantId = vid;
      node.dataset.poVariantPrice = unitPrice;
      node.dataset.poLineTotal = lineTotalCents;
    });

    // 2) Fire variant-change signals on the theme's (now nameless) variant select,
    //    if it's still in the DOM. Some theme JS keeps a reference to the element
    //    and listens for `change` regardless of whether name was stripped.
    //    Skip during init — see comment in syncFormInputs.
    if (!state.initializing) {
      Array.prototype.forEach.call(document.querySelectorAll('select[data-po-disabled-name="id"]'), function(sel){
        try { sel.value = vid; } catch(e){}
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // 3) Dispatch custom events that several Shopify themes listen for.
    //    Skip during init — see comment in syncFormInputs.
    if (!state.initializing) {
      var detail = {
        variant: { id: Number(vid), price: unitPrice },
        quantity: qty,
        lineTotal: lineTotalCents
      };
      try { document.body.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: detail })); } catch(e){}
      try { document.body.dispatchEvent(new CustomEvent('product:variant_changed', { bubbles: true, detail: detail })); } catch(e){}
      var poForm = $widget.closest('form');
      if (poForm) {
        try { poForm.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: detail })); } catch(e){}
      }
    }
  }

  // ---------- Quantity stepper ----------
  function setQuantity(n) {
    var q = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
    state.quantity = q;
    if ($qtyDisplay) $qtyDisplay.value = q;
    if ($qtyInput) $qtyInput.value = q;
    if ($qtyMinus) $qtyMinus.disabled = (q <= 1);
    refreshTotals();
    broadcastVariantChange();
  }

  // ---------- Card events ----------
  function bindCardClick(card, handler) {
    if (!card) return;
    var header = card.querySelector('.po-card-header');
    if (!header) return;
    header.addEventListener('click', function(e){
      if (e.target.closest('.po-card-body')) return;
      // is-disabled is only ever applied to the starter card (eligibility/redemption/single-variant-sold-out).
      // Sub & one-time cards stay clickable even when all variants are out of stock — users can still browse.
      if (card.classList.contains('is-disabled')) return;
      handler();
    });
  }
  bindCardClick($starterCard, selectStarter);
  bindCardClick($subCard, function(){
    // Prefer current selection; otherwise pick a sensible default (available preferred)
    var current = groups.subscription.find(function(x){ return x.id === state.subVariantId; });
    var v = current || pickDefaultAvailable(groups.subscription);
    if (v) selectSubscriptionVariant(v.id);
  });
  bindCardClick($otCard, function(){
    var current = groups.onetime.find(function(x){ return x.id === state.otVariantId; });
    var v = current || pickDefaultAvailable(groups.onetime);
    if (v) selectOneTimeVariant(v.id);
  });

  if ($planSelect) {
    $planSelect.addEventListener('change', function(){
      state.subSellingPlanId = $planSelect.value ? Number($planSelect.value) : null;
      // Re-render the sub card price (per-can may shift) and totals
      if (state.subVariantId) {
        var v = groups.subscription.find(function(x){ return x.id === state.subVariantId; });
        if (v) {
          var displayPrice = getSubscriptionPrice();
          var perCan = displayPrice / v.total_cans;
          setText($subCard.querySelector('[data-po="sub-price"]'), fmt(perCan) + '/' + CONTAINER);
          setText($subCard.querySelector('[data-po="sub-compare"]'), BASELINE_PER_UNIT > perCan ? fmt(BASELINE_PER_UNIT) : '');
        }
      }
      syncFormInputs();
      refreshTotals();
    });
    $planSelect.addEventListener('click', function(e){ e.stopPropagation(); });
  }

  if ($qtyMinus) $qtyMinus.addEventListener('click', function(e){
    e.preventDefault(); e.stopPropagation();
    setQuantity(state.quantity - 1);
  });
  if ($qtyPlus) $qtyPlus.addEventListener('click', function(e){
    e.preventDefault(); e.stopPropagation();
    setQuantity(state.quantity + 1);
  });
  if ($qtyDisplay) {
    $qtyDisplay.addEventListener('input', function(){
      var v = parseInt($qtyDisplay.value, 10);
      if (!isNaN(v)) state.quantity = Math.max(1, Math.min(99, v));
      if ($qtyInput) $qtyInput.value = state.quantity;
      refreshTotals();
    });
    $qtyDisplay.addEventListener('blur', function(){ setQuantity($qtyDisplay.value); });
  }

  // ---------- Modal (with scrollbar-stable body lock) ----------
  function getScrollbarWidth() {
    return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
  }
  function lockBodyScroll() {
    var sbw = getScrollbarWidth();
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.style.overflow = 'hidden';
  }
  function unlockBodyScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  // Format a list of integers as a natural-language list, e.g.:
  //   [4]          -> "4"
  //   [4, 8]       -> "4 or 8"
  //   [1, 4, 8, 12] -> "1, 4, 8, or 12"
  function formatSizesAsList(sizes) {
    if (sizes.length === 0) return '';
    if (sizes.length === 1) return String(sizes[0]);
    if (sizes.length === 2) return sizes[0] + ' or ' + sizes[1];
    return sizes.slice(0, -1).join(', ') + ', or ' + sizes[sizes.length - 1];
  }

  function buildModalContent(mode) {
    if (!$modal) return;

    // ----- One-Time paragraph (shared by both modal modes) -----
    var sizes = groups.onetime.map(function(v){ return v.sku_count; });
    sizes.sort(function(a,b){ return a - b; });
    var sizesText = formatSizesAsList(sizes);
    var unit = sizes.length === 1 ? unitWord(sizes[0]) : CONTAINER_PLURAL;
    var onetimeBody = sizes.length
      ? 'Choose between ' + sizesText + ' ' + unit + ' bundles that are not part of our subscription plan.'
      : '';
    setText($modal.querySelector('.po-modal-onetime-body'), onetimeBody);

    // ----- Title + topic paragraph (mode-specific) -----
    var $title = $modal.querySelector('.po-modal-title');
    var $topic = $modal.querySelector('[data-po-modal-topic]');
    if (!$title || !$topic) return;

    if (mode === 'starter' && groups.starter) {
      // ===== Starter Bundle Terms =====
      var s = groups.starter;
      var freeN = Math.max(0, s.total_cans - s.paid_cans);

      setText($title, s.total_cans + ' ' + capitaliseFirst(unitWord(s.total_cans)) + ' Starter Bundle Terms');

      var starterHeading = s.total_cans + ' ' + capitaliseFirst(unitWord(s.total_cans)) + ' Starter Bundle:';
      var starterBody = 'Buy ' + s.paid_cans + ' ' + unitWord(s.paid_cans) + ', get the ' +
                        (freeN === 1 ? 'next' : 'next ' + freeN) + ' ' + unitWord(freeN) + ' for free.';

      // Renewal target: 2nd-largest sub pack (or largest if only 1 exists)
      var subDescending = groups.subscription.slice().sort(function(a,b){ return b.sku_count - a.sku_count; });
      var renewTarget = subDescending[1] || subDescending[0];
      if (renewTarget) {
        var renewWeeks = recommendedWeeksForCount(renewTarget.sku_count);
        starterBody += ' After your starter bundle, this automatically renews into a ' +
                       renewTarget.sku_count + ' ' + unitWord(renewTarget.sku_count) +
                       ' subscription delivered ' + weeksToPhrase(renewWeeks) + '.';
      }
      starterBody += ' This offer is available only to new customers and is limited to one per household.';

      // Build paragraph: <strong>{heading}</strong> <span>{body}</span>
      $topic.innerHTML = '<strong></strong> <span></span>';
      setText($topic.querySelector('strong'), starterHeading);
      setText($topic.querySelector('span'), starterBody);

    } else {
      // ===== Subscribe & Save Terms (default for subscription mode AND any unknown) =====
      setText($title, 'Subscribe & Save Terms');

      var subSizes = groups.subscription.map(function(v){ return v.sku_count; });
      subSizes.sort(function(a,b){ return a - b; });
      var subSizesText = formatSizesAsList(subSizes);
      var subUnit = subSizes.length === 1 ? unitWord(subSizes[0]) : CONTAINER_PLURAL;

      var subBody = 'Choose a recurring subscription of ' + subSizesText + ' ' + subUnit +
                    '. Schedule your deliveries from every 1 week to every 10 weeks, with free express air shipping.';

      // Free-units callouts: only mention bundles where paid_cans < total_cans
      // (i.e. the bundle includes free units as part of the subscription deal).
      // For the typical OLS catalog these don't exist on subscription bundles
      // (free units tend to live on starter only), but the logic is here in
      // case any product has a "buy N get M free" subscription bundle.
      var freeCallouts = [];
      groups.subscription.forEach(function(v) {
        if (v.paid_cans && v.total_cans && v.paid_cans < v.total_cans) {
          var free = v.total_cans - v.paid_cans;
          freeCallouts.push(
            v.total_cans + '-' + unitWord(v.total_cans) + ' subscriptions include ' +
            free + ' free ' + unitWord(free) + ' per delivery'
          );
        }
      });
      if (freeCallouts.length) {
        subBody += ' ' + freeCallouts.join('; ') + '.';
      }

      $topic.innerHTML = '<strong></strong> <span></span>';
      setText($topic.querySelector('strong'), 'Subscribe & Save:');
      setText($topic.querySelector('span'), subBody);
    }
  }
  function openModal(mode) {
    if (!$modal) return;
    buildModalContent(mode);
    lockBodyScroll();
    // Remove the [hidden] attribute that was on the markup to prevent
    // unstyled-flash during initial page parse. From now on, visibility is
    // class-driven (.is-open) for the fade transition.
    $modal.hidden = false;
    // Force a reflow so the visibility/opacity baseline applies before the
    // class-add triggers the transition.
    $modal.offsetHeight;
    $modal.classList.add('is-open');
  }
  function closeModal() {
    if (!$modal) return;
    $modal.classList.remove('is-open');
    unlockBodyScroll();
  }
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-po-open-modal]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      // Determine which modal mode to show, based on which card the trigger
      // lives inside. Each card has data-mode = 'starter' | 'subscription' |
      // 'onetime'. (One-time has no triggers currently — but if added later
      // they'd default through to the Subscribe & Save modal, which is the
      // closest fit for "subscription/bundle terms".)
      // A trigger may name its mode directly. The redesign's plan cards are not
      // .po-card and never will be — that class carries the old widget's whole
      // look — so data-po-mode is how they choose between the starter terms and
      // the Subscribe & Save terms.
      var card = trigger.closest('.po-card');
      var mode = trigger.getAttribute('data-po-mode') || (card && card.dataset.mode) || 'subscription';
      openModal(mode);
      return;
    }
    var closer = e.target.closest('[data-po-close-modal]');
    if (closer) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeModal();
    }
  }, true);  // capture phase — runs before any bubble-phase handlers
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && $modal && $modal.classList.contains('is-open')) closeModal();
  });

  // ---------- Utility ----------
  function setText(el, text) { if (el) el.textContent = text; }
  function capitaliseFirst(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  // ---------- Init ----------
  // Strip name="id" from any pre-existing select (theme variant select)
  Array.prototype.forEach.call(document.querySelectorAll('select[name="id"]'), function(sel){
    if (sel.id !== 'po-variant-id') {
      sel.removeAttribute('name');
      sel.setAttribute('data-po-disabled-name', 'id');
    }
  });

  // Strip name="quantity" from theme inputs (only ours submits)
  var poForm = $widget.closest('form');
  if (poForm) {
    Array.prototype.forEach.call(poForm.querySelectorAll('input[name="quantity"]'), function(input){
      if (input.id === 'po-quantity') return;
      input.removeAttribute('name');
      input.setAttribute('data-po-disabled-name', 'quantity');
    });

    // Hide theme's existing Add to Cart button + qty stepper + price row
    var themeAtc = poForm.querySelector('#AddToCart-product-template-3, button[name="add"]:not(.po-atc-btn)');
    if (themeAtc) {
      var atcContainer = themeAtc.closest('.product-form__item--submit') || themeAtc.parentElement;
      (atcContainer || themeAtc).style.display = 'none';
    }
    Array.prototype.forEach.call(poForm.querySelectorAll('.js-qty'), function(stepper){
      var container = stepper.closest('.product-form__item--quantity') || stepper.parentElement;
      (container || stepper).style.display = 'none';
    });
    Array.prototype.forEach.call(poForm.querySelectorAll('.loop-current-product-price'), function(p){
      var row = p.closest('.d-flex') || p.parentElement;
      if (row && !row.contains($widget)) row.style.display = 'none';
    });
  }

  // Suppress transitions for the very first paint so the active card doesn't
  // visibly "expand into view" on page load.
  $widget.classList.add('po-widget--no-transition');

  renderStarter();
  renderSubscription();
  renderOneTime();

  // Apply stock-driven disables BEFORE picking a default mode, so we don't
  // accidentally land on an entirely-sold-out card.
  applyStockDisableStates();

  // Default selection: starter (if present + available + not disabled) →
  //                    subscription (if has any available variant) →
  //                    onetime (if has any available variant)
  var subHasAvailable = groups.subscription.some(function(v){ return v.available; });
  var otHasAvailable  = groups.onetime.some(function(v){ return v.available; });

  if (groups.starter && groups.starter.available && !state.starterDisabled) {
    selectStarter();
  } else if (subHasAvailable) {
    var subDefault = pickDefaultAvailable(groups.subscription);
    if (subDefault) selectSubscriptionVariant(subDefault.id);
  } else if (otHasAvailable) {
    var otDefault = pickDefaultAvailable(groups.onetime);
    if (otDefault) selectOneTimeVariant(otDefault.id);
  } else {
    // Nothing purchasable — leave mode null. syncAtcDisabled() will handle the button.
    syncAtcDisabled();
  }

  // Ensure plan-select section starts in the right visibility state
  updatePlanSelectVisibility();

  // Apply server-rendered starter disable (paints the badge + greys the card).
  // Done AFTER the cards have been rendered + a default selected.
  if (state.starterDisabled && groups.starter) {
    disableStarter(state.starterDisableReason || 'returning');
  }

  // Async: also check the live cart (catches "added in another tab" / "already in cart")
  checkCartForStarter();

  // ---------- Post-ATC eligibility re-check ----------
  // The starter card is only allowed once per customer. Without this hook, a
  // user could land on the page (clean cart → starter card enabled), click
  // ATC repeatedly, and stack quantity to 2+ before any re-evaluation runs.
  //
  // Strategy: hook XMLHttpRequest opens, watch for /cart/add completions, and
  // on each successful add invalidate our cart-cache + re-run the starter
  // check. checkCartForStarter() will see the freshly-added starter and call
  // disableStarter('in_cart'), which dulls the card, paints the "Already in
  // Your Cart" badge, and (because state.mode was 'starter') falls the
  // selection through to the next-best AVAILABLE option (sub or one-time).
  //
  // Race protection: between the click and the XHR loadend (~150–400ms), a
  // fast double-click would still fire two /cart/add posts back-to-back
  // before the re-check completes — both would succeed and the user ends up
  // with starter quantity 2. To plug that, we also block click events on
  // the ATC while a starter add is in flight (only in starter mode — other
  // modes can be rapid-clicked freely if the user wants two of the same
  // bundle, which is a legitimate use case).
  //
  // Note: this hook relies on the theme's ATC handler using XHR (most
  // Shopify themes do). If a theme switched to fetch(), we'd need a fetch
  // hook too, but the OLS theme uses XHR confirmed via live testing.
  var _atcInFlight = false;
  function setupCartAddListener() {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      var xhr = this;
      if (typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/i.test(url)) {
        xhr.addEventListener('loadend', function() {
          _atcInFlight = false;
          if (xhr.status >= 200 && xhr.status < 300) {
            invalidateCartCache();
            checkCartForStarter();
          }
        });
      }
      return origOpen.apply(this, arguments);
    };
  }
  setupCartAddListener();

  if ($atcBtn) {
    $atcBtn.addEventListener('click', function(e) {
      // Only intervene in starter mode. Subscribe / one-time clicks pass
      // through unchanged so the user can still rapid-add multiple bundles.
      if (state.mode !== 'starter') return;
      if (_atcInFlight) {
        // A starter add is already in progress — block this duplicate click
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      _atcInFlight = true;
      // Failsafe: if the loadend handler never fires (network failure mid-flight,
      // or theme intercepts and prevents the XHR entirely), reset after 5s so
      // the user isn't permanently locked out.
      setTimeout(function() { _atcInFlight = false; }, 5000);
    }, true);  // capture phase — runs before theme's submit handler
  }

  setQuantity(1);
  refreshTotals();

  // Lift the no-transition guard and clear initializing flag after layout settles.
  // From this point on, future variant/qty changes are user-driven and should
  // dispatch change events / update URL.
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      $widget.classList.remove('po-widget--no-transition');
      state.initializing = false;
    });
  });

  // Expose for debugging
  window.PurchaseOptions = {
    state: state,
    groups: groups,
    baselinePerUnit: BASELINE_PER_UNIT,
    pluralize: pluralize,
    selectStarter: selectStarter,
    selectSubscriptionVariant: selectSubscriptionVariant,
    selectOneTimeVariant: selectOneTimeVariant,
    setQuantity: setQuantity,
    openModal: openModal,
    closeModal: closeModal,
    disableStarter: disableStarter,
    checkCartForStarter: checkCartForStarter,
    invalidateCartCache: invalidateCartCache,
    fetchCart: fetchCart,
    applyStockDisableStates: applyStockDisableStates,
    syncAtcDisabled: syncAtcDisabled,
    pickDefaultAvailable: pickDefaultAvailable
  };
})();
